import { configureStore } from '@reduxjs/toolkit';
//import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import sessionStorage from 'redux-persist/lib/storage/session'; // defaults to sessionStorage for web
import { persistStore, persistReducer } from 'redux-persist';

import rootReducer from './reducers/index';  // Your root reducer


const persistConfig = {
  key: 'root',
  storage:sessionStorage,
  whitelist: ['themes', 'risks', 'controls', 'compliance', 'security', 'context', 'cloudModels', 'config', 'residualRisk', 'monitors', 'riskScenarios'] 
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export const persistor = persistStore(store);
export default store;

